import { defineMessages } from 'react-intl-next';

export default defineMessages({
	redactionMarker: {
		id: 'editor-extensions.redaction-extension.redaction-marker-aria-label',
		defaultMessage: 'Redacted content. Your organization has removed sensitive data.',
		description: 'Aria label for redaction marker.',
	},
});
